import React from 'react'

// React Router
import { Outlet, useLocation } from "react-router-dom";

// Components
import AppbarComp from "../components/AppbarComp";
import DrawerComp from "../components/DrawerComp";

// MUI
import { Box } from '@mui/material';

export default function Root({ myMode, setMyMode }) {
    const location = useLocation();

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    return (
        <Box sx={{ overflowX: "hidden", overflowY: "auto" }}>
            {(location.pathname === "/") ? (
                <Outlet />
            ) : (
                (location.pathname === "/home" || location.pathname === "/create" || location.pathname === "/profile" || location.pathname === "/edit") ? (
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <DrawerComp setMyMode={setMyMode} myMode={myMode} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} handleDrawerClose={handleDrawerClose} handleDrawerTransitionEnd={handleDrawerTransitionEnd} />
                        <Box sx={{ flex: 1 }}>
                            <AppbarComp handleDrawerToggle={handleDrawerToggle} />
                            <Box sx={{ display: "flex", justifyContent: "center", mt: "70px" }}>
                                <Outlet />
                            </Box>
                        </Box>
                    </Box>
                ) : (<Outlet />)
            )}
        </Box>
    )
}